module.exports = __webpack_public_path__ + "img/icon_instagram_rotate_neg.a1b3594a.svg";